import React from "react";
import Header from "gatsby-theme-carbon/src/components/Header";

const CustomHeader = (props) => (
  <Header isSwitcherEnabled={false}>
    Credit Suisse Hackathon&nbsp;<span>Cloud CoP India</span>
  </Header>
);

export default CustomHeader;
